export default __webpack_public_path__ + "static/media/muncipalServices.3668a134.svg";